import { Injectable } from '@angular/core';

enum GAType {
  JS = 'js',
  Config = 'config',
  Event = 'event'
}

export class GAEventData {
  event_category: string;
  event_label: string;
  value?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  private analyticsId: string;

  constructor() {
    // define gtag placeholder: if not defined
    const _window = <any>window;
    if (!_window.gtag) {
      _window.dataLayer = _window.dataLayer || [];
      _window.gtag = function () { _window.dataLayer.push(arguments); };
    }
  }

  // setup analytics for SPA
  init(analyticsId: string) {
    this.analyticsId = analyticsId;

    // config
    this.gtag(GAType.JS, new Date());
    this.gtag(GAType.Config, analyticsId, {
      'send_page_view': false
    });
  }

  logPageView(path: string) {
    this.gtag(GAType.Config, this.analyticsId, {
      'page_path': path
    });
  }

  logEvent(action: string, actionData?: GAEventData) {
    this.gtag(GAType.Event, action, actionData);
  }

  private gtag(...args) {
    (<any>window).gtag(...args);
  }
}
